import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Divider from "@mui/material/Divider";
import {useState} from "react";
import {useNavigate} from "react-router-dom";

export interface MenuContentListItem {
    label: string,
    icon: any,
    href?: string
}

export default function MenuContent({mainListItems, secondaryListItems, endListItems}:
        {mainListItems: MenuContentListItem[],
        secondaryListItems: MenuContentListItem[][],
        endListItems: MenuContentListItem[]}) {

    const [selectedItem, setSelectedItem] = useState("Home");
    const navigate = useNavigate();

    const onClick = (e:MenuContentListItem) => {
        setSelectedItem(e.label);
        if (e.href) {
            if (e.href.startsWith('/')) {
                navigate(e.href);
            } else if (e.href.startsWith('#')) {
                window.location.hash = e.href
            } else {
                window.open(e.href, '_blank');
            }
        }
    }

    return (
        <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between'}}>
            <div style={{justifyContent: 'start'}}>
                <List dense>
                    {mainListItems.map((item, index) => (
                        <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton selected={item.label === selectedItem} onClick={() => onClick(item)}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>

                {secondaryListItems.map((itemList, index) => (
                    <div key={index}>
                        <Divider />
                        <List dense>
                            {itemList.map((item, index) => (
                                <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                                    <ListItemButton selected={item.label === selectedItem} onClick={() => onClick(item)}>
                                        <ListItemIcon>{item.icon}</ListItemIcon>
                                        <ListItemText primary={item.label} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </div>
                ))}
            </div>


            <div style={{justifyContent: 'start'}}>
                <Divider />
                <List dense>
                    {endListItems.map((item, index) => (
                        <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton selected={item.label === selectedItem} onClick={() => onClick(item)}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </div>
        </Stack>
    );
}
